<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.slider.tanimlama.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="sliderForm" :rules="rulesSlider" ref="sliderForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.slider.tanimlama.anaBaslik")'
                                              prop="anaBaslik">:
                                    <el-input
                                            v-model="sliderForm.anaBaslik"
                                            :placeholder='$t("src.views.apps.slider.tanimlama.anaBaslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.slider.tanimlama.altBaslik")'
                                              prop="altBaslik">:
                                    <el-input
                                            v-model="sliderForm.altBaslik"
                                            :placeholder='$t("src.views.apps.slider.tanimlama.altBaslikPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.slider.tanimlama.aciklama")'
                                              prop="aciklama">:
                                    <el-input
                                            type="textarea"
                                            v-model="sliderForm.aciklama"
                                            :placeholder='$t("src.views.apps.slider.tanimlama.aciklamaPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (1536x937)"'
                                              prop="resim">:
                                    <el-upload
                                            class="resimler"
                                            action=""
                                            list-type="picture-card"
                                            multiple
                                            :limit="1"
                                            :file-list="imageListMain"
                                            :auto-upload="false"
                                            accept=".jpg,.jpeg,.png"
                                            :on-change="imageUpload"
                                            :on-remove="imageRemove">
                                        <i slot="default" class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-button size="mini" class="margin-bottom-10" type="primary" v-on:click="sliderBg">Slider Background</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item>
                                    <el-checkbox v-model="checked">Slider'da Link Olsun Mu?</el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-collapse v-if="checked" style="margin-top: 10px" v-model="activeCollapse">
                        <el-row :gutter="10">
                            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.link1Baslik")'
                                                  name="3">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="link1">:
                                                <el-input
                                                        v-model="sliderForm.link1"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="link1">:
                                                <el-input
                                                        v-model="sliderForm.linkButon1"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.link2Baslik")'
                                                  name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                          prop="link2">:
                                                <el-input
                                                        v-model="sliderForm.link2"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                          prop="link1">:
                                                <el-input
                                                        v-model="sliderForm.linkButon2"
                                                        :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-col>
                        </el-row>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.slider.tanimlama.durum")'>
                            <el-row>
                                <div>
                                    <el-button size="mini" class="onayBtn"
                                               v-on:click="sliderGuncelle('sliderForm')"
                                               type="primary">
                                        {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                    </el-button>
                                </div>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.slider.tanimlama.oncekiSlider")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="sliderTuru">
                                        <el-tree
                                                :data="sliderList"
                                                @node-click="handleNodeClick"
                                                node-key="sliderKodu"
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                    <div style="font-style: italic">* Eklenen Slider'ın hangi Slider'dan
                                        sonra gelmesini istersiniz?
                                    </div>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import WsProvider from '../../../WSProvider/provider/WSProvider'

    let $ = JQuery;
    import draggable from 'vuedraggable'
    import sliderService from '../../../WSProvider/SliderService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import functions from '../../../functions'

    let base64 = require('base64_js');
    let userData5B = "";

    export default {
        name: "SliderDuzenle",
        components: {
            draggable
        },
        data() {
            return {
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                fileListServer: [],
                sliderDetayListKlon: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                //Tree
                visibleUstSlider: false,
                treeList: [],
                defaultProps: {
                    label: 'anaBaslik'
                },
                // Form
                checked: false,
                visibleSil: false,
                imageListMain: [],
                updateData: [],
                orjinalResimList: [],
                fileListMain: [],
                updateSliderId: "",
                sliderList: [],
                sliderForm: {
                    anaBaslik: "",
                    altBaslik: "",
                    aciklama: "",
                    resim: "",
                    background: "1",
                    durum: "1",
                    link1: '',
                    linkButon1: '',
                    link2: '',
                    linkButon2: '',
                    // sliderTuru: '0',
                    oncekiSliderKodu: '',
                },
                rulesSlider: {
                    anaBaslik: [{
                        required: true,
                        message: "Lütfen AnaBaşlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        mounted() {
            this.updateSliderId = this.$store.state.updateKodu;
            this.getSliderDetay(this.updateSliderId);
            this.sliderListe();
        },
        methods: {
            sliderBg(){window.open(sliderService.bg, '_blank');},
            handleNodeClick(data) {
                notification.Status('success', this, data.anaBaslik + ' slider seçildi.');
                this.sliderForm.oncekiSliderKodu = data.sliderKodu;
            },
            getSliderDetay(sliderKodu) {
                let self = this;
                sliderService.sliderDetay(sliderKodu).then((response) => {
                    if (response.status === 200) {
                        self.linkVisible = true;
                        if (response.data['resim']) {
                            $('.el-upload--picture-card').hide();
                            self.orjinalResimList.push(response.data['resim']);
                            self.imageListMain.push({
                                name: response.data['resim'],
                                url: sliderService.imageUrlOrta + response.data['resim']
                            });
                            this.sliderForm.resim = response.data.resim;
                        }
                        this.sliderForm.anaBaslik = response.data.anaBaslik;
                        this.sliderForm.altBaslik = response.data.altBaslik;
                        this.sliderForm.aciklama = response.data.aciklama;
                        this.sliderForm.oncekiSliderKodu = response.data.oncekiSliderKodu;
                        if(response.data.link1 || response.data.link2 || response.data.linkButon1 || response.data.linkButon2){
                            this.checked =true;
                        }
                        if (response.data.link1) {
                            this.sliderForm.link1 = response.data.link1;
                        }
                        if (response.data.link2) {
                            this.sliderForm.link2 = response.data.link2;
                        }
                        if (response.data.linkButon1) {
                            this.sliderForm.linkButon1 = response.data.linkButon1;
                        }
                        if (response.data.linkButon2) {
                            this.sliderForm.linkButon2 = response.data.linkButon2;
                        }
                        this.sliderForm.durum = response.data.durum;
                        this.sliderDetayListKlon = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            sliderListe() {
                sliderService.sliderKisaList().then((response) => {
                    if (response.status === 200) {
                        this.sliderList = response.data;
                        this.sliderForm.oncekiSliderKodu = this.sliderList[parseInt(this.sliderList.length - 1)].sliderKodu;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                this.sliderForm.resim = "";
                $('.el-upload--picture-card').show();
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('slider', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                                this.sliderForm.resim = imgname;
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            imageUpload(file, fileList) {
                fileList.pop();
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.sliderForm.anaBaslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(this.sliderForm.anaBaslik) + ".jpg";
                        } else {
                            imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(this.sliderForm.anaBaslik) + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "slider-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sliderGuncelle(formName) {
                let self = this;

                for (var key in this.sliderDetayListKlon) {
                    if (this.sliderDetayListKlon[key] !== this.sliderForm[key]) {
                        if (this.sliderForm[key]) {
                            var item = {
                                type: key,
                                value: this.sliderForm[key]
                            };
                            this.updateData.push(item);
                        }
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (valid && this.updateData.length !== 0) {
                            sliderService.sliderGuncelle(this.updateSliderId, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', this, 'Slider başarıyla guncellendi.');
                                    this.resetForm(formName);
                                } else if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir slider zaten mevcut');
                                } else {
                                    notification.Status(response.status, this);
                                }
                            })
                        } else
                            notification.Status('warning', this, 'Değişiklik yapılmadı!');
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.imageListMain = [];
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "sliderduzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "sliderduzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .yanForm .card {
        margin-top: 10px;
    }
</style>